var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),[(!_vm.isIstore)?_c('emailReplyCopy'):_vm._e(),(!_vm.isIstore)?_c('emailReply'):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }